import React, { useEffect, useState } from 'react'
import { Modal, Button } from 'react-bootstrap';
import ReactLoading from 'react-loading';
import { Calendar } from "react-multi-date-picker";
import { ValidationForm, SelectGroup, TextInput, Checkbox } from 'react-bootstrap4-form-validation';
import Select, { createFilter } from "react-select";
import { ButtonDropdown, DropdownToggle, DropdownItem, DropdownMenu } from 'reactstrap';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import Swal from 'sweetalert2'
import { eachDayOfInterval, format, getDay, set } from 'date-fns';
import { useSelector } from 'react-redux';

import api from "../../../services/api"
import { defaultHeaders } from '../../../services/auth';
import Mapa from '../../../components/Mapa'
import { Aguarde, getCookie, getFileSize, zipUrls } from '../../../helpers/general'
import { confirmSwal, swalError } from "../../../helpers/swal";
import "./styles.scss"
import MultSelectDate from '../../../components/MultSelectDate';
import { width } from '../../../helpers';

const _formatoData = 'yyyy-MM-dd'
const _formatoDataHora = 'yyyy-MM-dd HH:mm'
const weekDays = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"]
const months = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"]

export default function Agendamento({ show, callback, reload, dataSet, grupo, colaboradores }) {
    const [loading, setLoading] = useState(true)
    const [dataClientes, setDataClientes] = useState([])
    const [dataTiposAgendamento, setDataTiposAgendamento] = useState([])
    const [dataTecnicos, setDataTecnicos] = useState([])
    const [dataFeriados, setDataFeriados] = useState([])
    const [gravando, setGravando] = useState(false)
    const [fecharGravar, setFecharGravar] = useState(false)
    const [gravarPeriodo, setGravarPeriodo] = useState(false)

    const [tabActive, setTabActive] = useState(0)

    const [tipoAtendimento, setTipoAtendimento] = useState(-1)
    const [idTipoAtendimento, setIdTipoAtendimento] = useState('')
    const [tecnico, setTecnico] = useState([])
    const [observacao, setObservacao] = useState('')
    const [dataInicio, setDataInicio] = useState(null)
    const [horaInicio, setHoraInicio] = useState(null)
    const [dataFim, setDataFim] = useState(null)
    const [horaFim, setHoraFim] = useState(null)
    const [cliente, setCliente] = useState({})
    const [latitude, setLatitude] = useState(0)
    const [longitude, setLongitude] = useState(0)
    const [nova, setNova] = useState(false)
    const [id, setID] = useState(0)
    const [dropdownOpen, setOpen] = useState(false)
    const [dropdownOpenOptions, setOpenOptions] = useState(false)
    const [agendaLote, setAgendaLote] = useState(false)
    const [datas, setDatas] = useState();
    const [getLocation, setGetLocation] = useState(false)
    const [checkall, setCheckAll] = useState(false)

    const _login = useSelector((state) => state.login);

    const messageNotLocation = (e) => {
        e.preventDefault()
        NotificationManager.warning('O cliente selecionado não possui latitude e logitude cadastrados.', 'Atenção!', 4000);
    }

    const setLocation = (location) => {
        setLatitude(location.lat)
        setLongitude(location.lng)
    }

    const toggle = () => setOpen(!dropdownOpen);
    const toggleOptions = () => setOpenOptions(!dropdownOpenOptions);

    const handleDatas = (e) => {
        console.log("Agendamento.handleDatas(0): ", e)
        setDatas(e)
    }

    const clear = () => {
        setIdTipoAtendimento(-1)
        setTipoAtendimento(-1)
        setTecnico([])
        setObservacao('')
        setHoraInicio('')
        setDataFim('')
        setHoraFim('')
        setCliente('')
        setLatitude(null)
        setLongitude(null)
        setDataInicio('')
        setNova(true)
        setDatas([new Date()])
        setID(0)
        setTabActive(0)
    }

    const setData = async () => {
        setTabActive(0)
        if (dataSet.startStr !== undefined) {
            setIdTipoAtendimento(-1)
            setTipoAtendimento(-1)

            if (dataSet.idtecnico > 0) {
                setTecnico(dataTecnicos.filter(_item => parseInt(_item.value) === parseInt(dataSet.idtecnico)))
            } else
                setTecnico([])
            setObservacao('')
            setHoraInicio(null)
            setDataFim(dataSet.endStr)
            setHoraFim(null)
            setCliente('')
            setLatitude(0);
            setLongitude(0);
            setDataInicio(dataSet.startStr)
            setNova(true)
            setID(0)
        } else {
            setNova(false)
            setID(dataSet.AGENDAID)
            setDataInicio(dataSet.DATA_INI)
            setHoraInicio(dataSet.HORA_INI)
            setDataFim(dataSet.DATA_FIN)
            setHoraFim(dataSet.HORA_FIN)
            setTipoAtendimento(dataSet.TIPO)
            setIdTipoAtendimento(dataSet.IDTIPO)
            setObservacao(dataSet.OBSERVACAO)
            setLatitude(dataSet.LATITUDECLI);
            setLongitude(dataSet.LONGITUDECLI);
            setTecnico(dataTecnicos.filter(_item => parseInt(_item.value) === parseInt(dataSet.TECNICOID)))
            setCliente({ 'label': dataSet.CLIENTE, 'value': dataSet.CLIENTEID })
        }
    }

    const getData = async () => {
        console.log("agendamento.getData(getData())")
        setLoading(true)
        await api.post('/agenda/buscarinfoagendamento', { headers: defaultHeaders() })
            .then(response => {
                // if (grupo)
                //     setDataTecnicos(response.data.tecnicos.filter(_item => _item.GRUPO === grupo))
                // else
                //-- retornar apenas as duas primeiras palavras do nome do técnico

                const _tenicos = response?.data?.tecnicos?.filter(_item => !grupo || _item.GRUPO == grupo || _item.GRUPO_COLABORADORES == grupo)
                    .map(_item => ({ ..._item, label: _item.NOME.split(" ").slice(0, 2).join(" ") + " - " + _item.CNPJ_CPF }))
                setDataTecnicos(_tenicos)
                setDataClientes(response.data.clientes)
                setDataTiposAgendamento(response.data.tipos)
                handleTipo(1, 'AGENDAMENTO')
                setDataFeriados(response.data.feriados)
                setTimeout(() => {
                    setLoading(false)
                }, 2000)

            })
            .catch(error => {
                setLoading(false)
                console.log(error)
            })

    }

    const handleSubmitMult = async (e) => {
        if (e)
            e.preventDefault();

        if (!datas || datas.length <= 0) {
            swalError({ title: `Não foi possível gravar o(s) agendamento(s), favor informar todos os campos!`, });
            return
        }

        // console.log("agendamento.handleSubmitMult(datas): ", datas)


        let _cliente = cliente.value

        if (tecnico.length <= 0) {
            NotificationManager.error(
                "Informe pelo menos 1 técnico para realizar o agendamento",
                "Erro!",
                4000
            );
            return
        }

        // console.log("agendamento.handleSubmmit(_dates): ", _dates)
        setGravando(true)
        if (gravarPeriodo) {
            for (const [idx, _tecnico] of tecnico.entries()) {
                await handlePost(_tecnico, _cliente, datas[0], datas[1], idx)
            }
        }
        else
            for (let i = 0; i < datas.length; i++) {
                const _row = datas[i];
                // const _date = new Date(_row)
                // console.log("agendamento.handleSubmmit(_row): ", _date)
                // let isHoliday = dataFeriados.filter(_feriado => _feriado === format(_date, 'dd/MM'))

                // if ((isHoliday.length > 0) || [0, 6].includes(getDay(_date)))
                //     continue


                for (const [idx, _tecnico] of tecnico.entries()) {
                    await handlePost(_tecnico, _cliente, _row, _row, idx)
                }
            }

        setAgendaLote(false)
        setGravando(false)
        clear()
        reload(true)
        if (fecharGravar)
            callback(false)
        // callback(false)
    }

    const handlePost = async (tecnico, cliente, dataI, dataF, idx) => {

        let _data = {
            tipoAtendimento: (!tipoAtendimento || tipoAtendimento < 0) ? null : tipoAtendimento,
            idTipoAtendimento: (!idTipoAtendimento || idTipoAtendimento < 0) ? null : idTipoAtendimento,
            tecnico: tecnico.PESSOAID,
            observacao,
            dataInicio: format(new Date(dataI), _formatoData),
            horaInicio: format(new Date('2023-01-01 ' + (idx === 0 ? horaInicio ? horaInicio : '08:00' : '08:00')), 'HH:mm'),
            dataFim: format(new Date(dataF || dataI), _formatoData),
            horaFim: format(new Date('2023-01-01 ' + (idx === 0 ? horaFim ? horaFim : '18:00' : '18:00')), 'HH:mm'),
            cliente: cliente,
            latitude,
            usuarioid: _login.usuarioid,
            nomeTecnico: tecnico.NOME,
            longitude,
            nova,
            id,
            lote: !gravarPeriodo && datas.length > 1,
        }

        await api.post('/agenda/gravaragenda', _data, { headers: defaultHeaders() })
            .then(response => {

            })
            .catch(error => {
                console.log(error)
            })
    }

    const loadOptions = (input, callback) => {
        callback(dataClientes.filter(({ label }) => {
            return (label.toUpperCase().indexOf(input.toUpperCase()) >= 0)
        }));
    };

    const handleTipo = (id, nome) => {
        setIdTipoAtendimento(id)
        setTipoAtendimento(nome)
    }

    const handleTecnico = (data) => {
        setTecnico(data)
    }

    const cancelar = async (e) => {
        e.preventDefault();

        Swal.fire({
            text: "Deseja realmente cancelar o agendamento?",
            icon: 'warning',
            title: 'Cancelar Agendamento',
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: 'Continuar',
            confirmButtonColor: '#d33',
            cancelButtonText: `Sair`,
        }).then(async (result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                await api.delete('/agenda/cancelaragenda/' + id, { headers: defaultHeaders() })
                    .then(response => {
                        reload(true)
                        callback(false)
                    })
                    .catch(error => {
                        Swal.fire('Erro ao cancelar o agendamento!', '', 'error')
                        console.log(error)
                    })
            }
        })
    }

    const handleCheckAll = () => {
        if (checkall)
            setTecnico([])
        else
            setTecnico(dataTecnicos)
        setCheckAll(!checkall)

    }

    useEffect(() => {
        console.log("agendamento.useEffect(dataSet): ", dataSet)
        const _dataI = dataSet?.DATA_INI || dataSet?.startStr

        if (_dataI) {
            console.log("agendamento.useEffect(_dataI): ", _dataI)
            const _data = _dataI.toString().split('-')
            const _days = new Date(_data[0], _data[1] - 1, _data[2])
            // let _days = format(new Date(_dataI), 'dd/mm/yyyy')
            console.log(_days)
            //const _data = new Date(_days[0], _days[1] - 1, _days[2])
            console.log("agendamento.useEffect(data): ", _days)
            setDatas([_days])
        }
        if (JSON.stringify({}) !== JSON.stringify(dataSet))
            setData()
    }, [dataSet])

    useEffect(() => {
        getData()
    }, [])

    function GetCalendar() {
        return (
            <div>


                <Calendar
                    value={datas}
                    onChange={(e) => handleDatas(e)}
                    multiple={true}
                    format="DD-MM-YYYY"
                    weekDays={weekDays}
                    months={months}
                    range={gravarPeriodo}
                />
                <div style={{ marginTop: "8px" }} title='Gravar período irá gravar o agendamento com data inicial e final'>
                    <input type="checkbox" checked={gravarPeriodo} value={gravarPeriodo} onChange={() => setGravarPeriodo(!gravarPeriodo)} />
                    <span style={{ marginLeft: "5px", marginTop: "-1px" }}>Gravar Período?</span>
                </div>
                {/* <button style={{ marginLeft: "0px", marginTop: "5px" }} onClick={handleDate}>Send</button> */}
            </div>
        );
    }

    return (
        <>
            {getLocation && <Mapa handleClose={() => setGetLocation(false)} setLocation={setLocation} />}
            {gravando && <Aguarde legenda="Aguarde, gravando dados..." />}
            <Modal show={show} size={width() == "mobile" ? "sm" : "lg"} aria-labelledby="contained-modal-title-vcenter" centered onHide={() => callback(false)} id="agendamento-modal">
                <NotificationContainer />
                <ValidationForm setFocusOnError={true} id="form">
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            <i className="fa fa-calendar" /> Agendamento
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ paddingTop: "1px", backgroundColor: "#F8F7F7", overflow: "auto" }}>

                        {loading ?
                            <div style={{ justifyContent: "center", height: "440px", display: "flex", alignItems: "center", width: "100%" }}>
                                <ReactLoading type='spin' color='#007bff' height={35} width={35} />
                            </div>
                            :
                            <div className={width() == "mobile" ? 'containersm' : 'containerlg'}>
                                <ul className="nav nav-tabs" id="tabAgenda" role="tablist">
                                    <li className="nav-item w-100px">
                                        <span onClick={e => setTabActive(0)} className={`nav-link ${tabActive === 0 ? 'active' : ''}`} id="geral-tab" data-toggle="tab" role="tab" aria-controls="home" aria-selected="true">Dados</span>
                                    </li>
                                    <li className="nav-item w-100px" style={{width :"100px"}}>
                                        <span onClick={e => setTabActive(1)} className={`nav-link ${tabActive === 1 ? 'active' : ''}`}  id="profile-tab" data-toggle="tab"  role="tab" aria-controls="profile" aria-selected="false">Observação</span>
                                    </li> 
                                </ul>
                                <div class="tab-content">
                                    <div className={`tab-pane fade ${tabActive === 0 ? 'show active' : ''}`} id="dados" role="tabpanel" aria-labelledby="dados-tab" style={{border:"1px solid rgb(233,233,233)", padding:"5px"}}>
                                        <div className={width() === "mobile" ? 'coluna1sm' : 'coluna1lg'} >
                                            <div>
                                                <label>Cliente</label>
                                                <Select
                                                    id="idcliente"
                                                    filterOption={createFilter({ ignoreAccents: false })}
                                                    options={dataClientes}
                                                    value={cliente}
                                                    autoFocus
                                                    loadOptions={loadOptions}
                                                    onChange={value => setCliente(value === null ? 0 : value)}
                                                    placeholder="Digite para pesquisar..."
                                                    loadingMessage={() => 'Carregando, Aguarde...'}
                                                    noOptionsMessage={() => 'Não encontrado'} />

                                                <div className="hidden" id="msg-invalid-cliente" style={{ width: "100%", marginTop: "0.25rem", fontSize: "80%", color: "#dc3545" }}>Por favor, informe um cliente!</div>
                                            </div>
                                            <div>
                                                <label>Tipo de Agendamento</label>
                                                <SelectGroup
                                                    name="tipoatendimento"
                                                    id="tipoatendimento"
                                                    placeholder="Selecione"
                                                    required
                                                    errorMessage={{ required: "Por favor, informe um tipo de atendimento!" }}
                                                    className="form-select "
                                                    style={{ fontSize: "12px", color: "#515253 " }}
                                                    value={idTipoAtendimento}
                                                    onChange={e => handleTipo(parseInt(e.target.value), e.target.options[e.target.selectedIndex].text)}>
                                                    <option value="">Selecione</option>
                                                    {dataTiposAgendamento.map((data, id) => {
                                                        return (<option key={id} value={data.ID}>{data.NOME}</option>)
                                                    })}
                                                </SelectGroup>
                                            </div>
                                   
                                            <div style={{ display: "flex", maxHeight: "500px" }} className={`${checkall ? 'checkall' : ''}`}>
                                                <div style={{ width: "100%", maxHeight: "200px" }}>
                                                    <div style={{ display: "flex" }}>
                                                        <label>Agendado para</label>
                                                        <div style={{ marginLeft: "30px" }}>
                                                            <div style={{ marginTop: "8px" }}>
                                                                <input type="checkbox" checked={checkall} value={checkall} onChange={e => handleCheckAll()} />
                                                                <span style={{ marginLeft: "5px", marginTop: "-1px" }}>Marcar todos?</span>
                                                            </div>  
                                                        </div>
                                                    </div>
                                                    <Select
                                                        id="idtecnico"
                                                        options={dataTecnicos}
                                                        value={tecnico}
                                                        isMulti
                                                        onChange={handleTecnico}
                                                        placeholder="Digite para pesquisar..."
                                                        loadingMessage={() => 'Carregando, Aguarde...'}
                                                        noOptionsMessage={() => 'Não encontrado'} />

                                                    <div className="hidden" id="msg-invalid-colaborador" style={{ width: "100%", marginTop: "0.25rem", fontSize: "80%", color: "#dc3545" }}>Por favor, informe um colaborador!</div>
                                                </div>
                                            </div>

                                            <div className="form-div-agenda-control">
                                                <div style={{ display: "flex" }}>
                                                    <div>
                                                        <label>Latitude</label>
                                                        <input type="text" value={latitude} className="form-control" onChange={e => setLatitude(e.target.value)} />
                                                    </div>
                                                    <div>
                                                        <label>Longitude</label>
                                                        <input type="text" value={longitude} className="form-control" onChange={e => setLongitude(e.target.value)} />
                                                    </div>
                                                    <div style={{ display: 'flex', alignItems: "center", width: '50px' }} title="Obter Geolocalização">
                                                        <button type="button" className="btn btn-success" style={{ marginTop: "26px", minWidth: "32px" }} onClick={e => setGetLocation(true)}><i className="fa fa-map-marker-alt" /></button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div style={{ display: "flex", flexDirection: "column", opacity: "0.5", marginTop: "10px" }}>
                                                <div style={{ display: "flex", flexDirection: "row", }}>
                                                    {dataSet.USUARIOI && <div >Inclusão: <span style={{ fontWeight: "bold", marginRight: "15px" }}>{dataSet.USUARIOI.split(" ").slice(0, 2).join(" ")}</span></div>}
                                                    {dataSet.USUARIOA && <div >Alteração: <span style={{ fontWeight: "bold" }}>{dataSet.USUARIOA.split(" ").slice(0, 2).join(" ")}</span></div>}
                                                </div>
                                                {dataSet.VENDEDOR && <div >Vendedor: <span style={{ fontWeight: "bold" }}>{dataSet.VENDEDOR.split(" ").slice(0, 2).join(" ") || "(Não informado)"}</span></div>}
                                            </div>
                                            <div className={width() == "mobile" ? 'coluna2sm' : 'coluna2lg'} >
                                                <div className={`${width() == "mobile" ? "" : "text-center"} font-weight-bold`}>Data(s) de Agendamento</div>
                                                <GetCalendar />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`tab-pane fade ${tabActive === 1 ? 'show active' : ''}`} id="observacao" role="tabpanel" aria-labelledby="observacao-tab" style={{border:"1px solid rgb(233,233,233)", padding:"5px"}}> 
                                        <div style={{display:"flex", gap:"8px"}}>
                                            <div style={{width:"20%", display:"flex", gap:"5px"}}>
                                                <span>Id:</span>
                                                <span>{id}</span>
                                            </div> 
                                        </div>
                                        <div style={{display:"flex", gap:"8px"}}>
                                            <div style={{display:"flex", gap:"5px"}}>
                                                <span>Agendado para:</span>
                                                <span>{tecnico.length > 0 ? tecnico[0].label : ''}</span>
                                            </div>
                                        </div>
                                        <div style={{display:"flex", gap:"8px", marginTop:"2px"}}>
                                            <div style={{width:"50%", display:"flex", gap:"5px"}}>
                                                <span>Data Inicial:</span>
                                                <span>{format(new Date(dataInicio), 'dd/MM/yyyy')}</span>
                                            </div>
                                            <div style={{width:"50%", display:"flex", gap:"5px"}}>
                                                <span>Data Final:</span>
                                                <span>{format(new Date(dataFim || dataInicio), 'dd/MM/yyyy')}</span>
                                            </div>
                                        </div>           
                                      
                                        <div style={{height:"431px"}}>
                                            <label>Observação</label>
                                            <textarea className="form-control" value={observacao} rows={20} onChange={e => setObservacao(e.target.value)}></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </Modal.Body>
                    {!agendaLote &&
                        <Modal.Footer style={{ padding: "3px", }}>
                            <div style={{ flexDirection: "initial", display: 'flex', justifyContent: "flex-start" }}>
                                <Checkbox name="chkFecharAoGravar" id="chkFecharAoGravar" onChange={setFecharGravar} label="Fechar ao gravar" /></div>
                            <div className={loading ? 'hidden-display' : ''} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button onClick={handleSubmitMult} variant="success" style={{ width: "100px" }}><i className="fa fa-save" /> Gravar</Button>
                                {width() != "mobile" &&
                                    <ButtonDropdown isOpen={dropdownOpenOptions} toggle={toggleOptions} direction="up" style={{ width: "100px", marginLeft: "10px" }} >
                                        <DropdownToggle caret size='sm' className="btn btn-warning">
                                            <i className="fa fa-cogs" style={{ marginRight: "5px" }} />
                                            Opções
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            <DropdownItem style={{ textDecoration: "none", color: '#6C757D' }} onClick={e => clear(e)}><i className="fa fa-eraser" /> Limpar</DropdownItem>
                                            {/* <DropdownItem style={{ textDecoration: "none", color: '#6C757D' }} onClick={() => setAgendaLote(true)}><i className="fa fa-calendar" /> Agendar Lote</DropdownItem> */}
                                            {dataSet.AGENDAID !== undefined ?
                                                <DropdownItem style={{ textDecoration: "none", color: '#6C757D' }} onClick={e => cancelar(e)}><i className="fa fa-ban" /> Cancelar</DropdownItem>
                                                : ''}
                                        </DropdownMenu>
                                    </ButtonDropdown>}
                                <ButtonDropdown isOpen={dropdownOpen} toggle={toggle} direction="up" style={{ width: "100px", marginLeft: "10px" }}>
                                    <DropdownToggle caret size='sm'>
                                        <i className="fa fa-route" style={{ marginRight: "5px" }} />
                                        Rota
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        {((latitude === null) || (longitude === null) || (latitude === '') || (longitude === '')) ?
                                            <>
                                                <DropdownItem><a style={{ color: "#000", textDecoration: "none" }} className="link-secondary" onClick={e => messageNotLocation(e)}><i className="fab fa-google" /> Google Maps</a></DropdownItem>
                                                <DropdownItem><a style={{ color: "#000", textDecoration: "none" }} className="link-secondary" onClick={e => messageNotLocation(e)}><i className="fab fa-waze" /> Waze</a></DropdownItem>
                                            </>
                                            :
                                            <>
                                                <DropdownItem><a target='_new' style={{ color: "#000", textDecoration: "none" }} className="link-secondary" href={`https://www.google.com/maps/dir/?api=1&origin=&destination=${latitude},${longitude}&travelmode=driving`}><i className="fab fa-google" /> Google Maps</a></DropdownItem>
                                                <DropdownItem><a target='_new' style={{ color: "#000", textDecoration: "none" }} className="link-secondary" href={`https://www.waze.com/ul?ll=${latitude}%2C${longitude}&navigate=yes&zoom=17`}><i className="fab fa-waze" /> Waze</a></DropdownItem>
                                            </>
                                        }
                                    </DropdownMenu>
                                </ButtonDropdown>
                            </div>
                            <Button type="button" style={{ width: "100px" }} onClick={e => callback(false)}><i className="fa fa-window-close" /> Sair</Button>
                        </Modal.Footer>}
                </ValidationForm>
            </Modal >
            {agendaLote && <MultSelectDate handleCloseEv={e => setAgendaLote(false)} handlePost={handleSubmitMult} modal={true} />
            }
        </>
    )
}